import { render } from "./AccessiblePagination.vue?vue&type=template&id=46160624&scoped=true"
import script from "./AccessiblePagination.vue?vue&type=script&lang=js"
export * from "./AccessiblePagination.vue?vue&type=script&lang=js"

import "./AccessiblePagination.vue?vue&type=style&index=0&id=46160624&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46160624"]])

export default __exports__
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPagination,QBtn});
